import { render, staticRenderFns } from "./CardTarjaEnqueteSportTVNewsQRCODE.vue?vue&type=template&id=4a60a0b2&scoped=true"
import script from "./CardTarjaEnqueteSportTVNewsQRCODE.vue?vue&type=script&lang=js"
export * from "./CardTarjaEnqueteSportTVNewsQRCODE.vue?vue&type=script&lang=js"
import style0 from "./CardTarjaEnqueteSportTVNewsQRCODE.vue?vue&type=style&index=0&id=4a60a0b2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a60a0b2",
  null
  
)

export default component.exports